import React from "react";

import './burger-button.scss';

const BurgerButton = ({onClickHandler}) => {
  return <button type="button" className="mobile-nav-opener" onClick={onClickHandler}><span>open</span></button>;
}

export default BurgerButton;